export default {
    computed: {
        template() {
            try {
                return this.$store.getters.getTemplateById(this.templateId)
            } catch (e) {
                console.warn(e)
            }
        },
        templateType() {
            return this.$store.getters.projectTypeById(this.template.projectType.id)
        },
        templateTasks() {
            return this.$store.getters.tasksByProjectId(this.templateId)
        },
    },
}
